import * as React from "react"

type PageHeaderProps = {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  tabs?: React.ReactNode
}

export function PageHeader({ title, description, actions, tabs }: PageHeaderProps) {
  return (
    <div>
      <div className="flex flex-col gap-5 border-b border-hairline pb-6 sm:flex-row sm:items-end sm:justify-between">
        <div className="max-w-3xl">
          <h1>{title}</h1>
          {description && <p className="mt-2 text-sm text-ink-muted sm:text-base">{description}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {tabs}
    </div>
  )
}
